import axios from "axios";
import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { PageShell } from "../HomeV2/HomeV2";

const jobData = [
  {
    id: "Dsr0014",
    title: "Research Engineer (Chemical Engineer)",
    location: "Dsider | India",
    position: "Entry Level (1-3 years)",
    postedOn: "Sep 03rd 2025",
    travel: "Minimal",
    workModel: "Remote",
    country: "India",
    aboutDsider: "Dsider is an AI-powered decision intelligence platform for the energy sector. We help companies transform complexity into clarity using AI models, digital twins, and decision modeling tools — driving smarter, faster, and more profitable decisions across the energy value chain.",
    theRole: "We're looking for a Research Engineer with a Chemical Engineering background to develop and validate process models for energy transition technologies. You'll apply your chemical engineering expertise to create accurate simulations for hydrogen production, carbon capture, biofuels, and other emerging energy processes.",
    responsibilities: [
      "Develop and validate chemical process models for energy technologies",
      "Design thermodynamic and kinetic models for emerging energy processes",
      "Collaborate with software engineers to integrate process simulations into our platform",
      "Research and analyze new energy technologies and their process requirements",
      "Validate model outputs against experimental data and industry benchmarks",
      "Support customer implementations with domain expertise",
      "Contribute to technical documentation and best practices",
      "Stay current with developments in energy transition technologies"

    ],
    qualifications: [
      "1+ years of experience in chemical engineering or related field.",
      "Education: Bachelor's/Master's in Chemical Engineering or related discipline.",
      "Process Modeling: Experience with process simulation software (Aspen Plus, HYSYS, or similar).",
      "Thermodynamics: Strong foundation in thermodynamics, heat transfer, and mass transfer.",
      "Programming: Basic proficiency in Python, MATLAB, or similar technical computing languages.",
      "Energy Processes: Understanding of chemical processes in energy applications.",
      "Problem Solving: Strong analytical and problem-solving capabilities.",
      "Communication: Ability to explain complex technical concepts clearly.",
      "Documentation: Strong technical writing skills."
    ],
    goodToHave: [
      "Experience with emerging energy technologies (hydrogen, CCUS, biofuels, geothermal)",
      "Knowledge of reaction kinetics and catalyst design",
      "Experience with CFD or other advanced simulation tools",
      "Understanding of process optimization and control",
      "Familiarity with energy industry standards and regulations",
      "Experience with data analysis and statistical methods",
      "Knowledge of life cycle assessment (LCA) methodologies"

    ]
  },
  {
    id: "Dsr0022",
    title: "Backend Engineer",
    location: "Dsider | India",
    position: "Intermediate Level (3-5 years)",
    postedOn: "Sep 03rd 2025",
    travel: "Minimal",
    workModel: "Remote",
    country: "India",
    aboutDsider: "Dsider is an AI-powered decision intelligence platform for the energy sector. We help companies transform complexity into clarity using AI models, digital twins, and decision modeling tools — driving smarter, faster, and more profitable decisions across the energy value chain.",
    theRole: "We're looking for a Backend Engineer to build robust, scalable server-side applications that power our AI-driven energy solutions. You'll design and implement APIs, manage data pipelines, and ensure our systems can handle complex energy simulations and large-scale data processing.",
    responsibilities: [
      "Design and develop scalable backend services and APIs using modern frameworks",
      "Build and maintain data processing pipelines for energy sector applications",
      "Integrate with AI/ML models and simulation engines",
      "Implement database solutions for complex energy data structures",
      "Ensure system reliability, performance, and security",
      "Collaborate with frontend engineers, data scientists, and domain experts",
      "Participate in code reviews and maintain high code quality standards",
      "Support deployment and monitoring of production systems."
    ],
    qualifications: [
      "3+ years of backend development experience.",
      "Languages: Proficiency in Python or similar backend technologies.",
      "Frameworks: Experience with Python FastAPI, Django or equivalent.",
      "Databases: Strong experience with SQL (PostgreSQL/MySQL) and NoSQL (MongoDB/Redis).",
      "APIs: Design and implementation of RESTful APIs.",
      "Cloud Platforms: Experience with AWS and Azure.",
      "DevOps: Understanding of Docker, basic CI/CD, and version control with Git.",
      "Data Processing: Experience with data pipelines and ETL processes.",
      "Testing: Unit testing and integration testing practices."
    ],
    goodToHave: [
      "Experience with real-time data streaming and processing",
      "Knowledge of energy sector data formats and simulations",
      "Experience with AI/ML model deployment and serving",
      "Familiarity with microservices architecture",
      "Understanding of message queues and event-driven architectures",
      "Experience with monitoring and logging tools."
    ]
  },
  {
    id: "Dsr0020",
    title: "UX Designer",
    location: "Dsider | India",
    position: "Intermediate Level (3+ years)",
    postedOn: "January 15, 2026",
    travel: "Minimal",
    workModel: "Currently remote. Candidate willing to relocate to Bengaluru in future",
    country: "India, Bengaluru preferred (Remote will be considered)",
    aboutDsider: (
  <>
    Dsider is building an <strong>AI-powered decision platform</strong> grounded
    in <strong> first-principles simulation, optimization, and domain-specific knowledge. </strong>
    Our systems combine deterministic modeling, multi-agent AI, and
    explainable decision logic to help organizations make complex,
    high-impact decisions with confidence.
    As we scale globally, India is a critical engineering and delivery
    hub for Dsider.
  </>
),
    theRole: "We're looking for a UX Designer to create intuitive and powerful user experiences for our AI-driven energy platform. You'll design interfaces that make complex energy data and simulations accessible to engineers, executives, and decision-makers across the energy industry.",
    responsibilities: [
      "Design user-centered interfaces for complex energy data visualization and analysis tools",
      "Conduct user research and usability testing with energy industry professionals",
      "Create wireframes, prototypes, and high-fidelity designs using modern design tools",
      "Develop design systems and component libraries for consistent user experiences",
      "Collaborate closely with product managers, engineers, and domain experts",
      "Translate complex technical requirements into intuitive user workflows",
      "Present design concepts and rationale to stakeholders"
    ],
    qualifications: [
      "3+ years of UX design experience with increasing responsibility",
      "Design Tools: Proficiency in Figma, Sketch, Adobe Creative Suite, or similar tools",
      "User Research: Experience with user interviews, usability testing, and persona development",
      "Prototyping: Strong skills in creating interactive prototypes and wireframes",
      "Design Systems: Experience building and maintaining design systems and component libraries",
      "Data Visualization: Understanding of effective data visualization principles and best practices",
      "Responsive Design: Strong knowledge of responsive and adaptive design principles",
      "Collaboration: Excellent communication skills and experience working with cross-functional teams",
      "Problem Solving: Ability to translate complex business requirements into user-friendly solutions",
      "Portfolio: Strong portfolio demonstrating UX process and design thinking"
    ],
    goodToHave: [
      "Experience designing for data-heavy or enterprise applications",
      "Knowledge of energy sector workflows and industry-specific requirements",
      "Understanding of AI/ML interfaces and decision support systems",
      "Experience with design for technical/scientific applications",
      "Basic understanding of frontend development (HTML, CSS, JavaScript)",
      "Experience with accessibility standards (WCAG) and inclusive design",
      "Knowledge of information architecture and complex data organization"
    ]
  },
  {
    id: "Dsr0023",
    title: "Frontend Engineer",
    location: "Dsider | India",
    position: "Intermediate Level (3+ years)",
    postedOn: "Sep 12th 2025",
    travel: "Minimal",
    workModel: "Currently remote. Candidate willing to relocate to Bengaluru in future",
    country: "India, Bengaluru preferred (Remote will be considered)",
    aboutDsider: "Dsider is an AI-powered decision intelligence platform for the energy sector. We help companies transform complexity into clarity using AI models, digital twins, and decision modeling tools — driving smarter, faster, and more profitable decisions across the energy value chain.",
    theRole: "We're looking for a Frontend Engineer to develop engaging user interfaces for our AI-driven energy solutions. You'll build responsive web applications, implement data visualization components, and create intuitive user experiences that make complex energy data accessible to decision-makers.",
    responsibilities: [
      "Develop responsive web applications using modern frontend frameworks",
      "Implement interactive data visualizations and dashboards for energy data",
      "Collaborate with UX designers to transform designs into functional interfaces",
      "Integrate frontend applications with backend APIs and AI/ML services",
      "Optimize application performance and ensure cross-browser compatibility",
      "Write clean, maintainable code following established coding standards",
      "Participate in code reviews and contribute to team knowledge sharing",
      "Support testing and quality assurance processes"
    ],
    qualifications: [
      "3+ years of frontend development experience",
      "Frontend Frameworks: Proficiency in React, Angular, or Vue.js (React preferred)",
      "Languages: Strong skills in JavaScript/TypeScript, HTML5, and CSS3",
      "Responsive Design: Experience with responsive web design and CSS frameworks",
      "Version Control: Proficiency with Git and collaborative development workflows",
      "APIs: Experience integrating with RESTful APIs and handling asynchronous data",
      "Build Tools: Familiarity with modern build tools (Webpack, Vite, etc.)",
      "Testing: Understanding of frontend testing practices and frameworks",
      "Problem Solving: Strong debugging and problem-solving capabilities"
    ],
    goodToHave: [
      "Experience with data visualization libraries (D3.js, Chart.js, Plotly)",
      "Knowledge of state management libraries (Redux, MobX)",
      "Understanding of performance optimization techniques",
      "Experience with component libraries and design systems",
      "Familiarity with energy sector applications and data visualization needs",
      "Experience with progressive web apps (PWA)",
      "Understanding of accessibility standards and best practices"

    ]
  },
  {
    id: "Dsr0010",
    title: "Senior Frontend Engineer",
    location: "Dsider | India",
    position: "Senior Level (6+ years)",
    postedOn: "Sep 24th 2025",
    travel: "Minimal",
    workModel: "Currently remote. Candidate willing to relocate to Bengaluru in future",
    country: "India, Bengaluru preferred (Remote will be considered)",
    aboutDsider: "Dsider is an AI-powered decision intelligence platform for the energy sector. We help companies transform complexity into clarity using AI models, digital twins, and decision modeling tools — driving smarter, faster, and more profitable decisions across the energy value chain.",
    theRole: "We're looking for a Senior Frontend Engineer to lead our user interface development and create exceptional user experiences for our AI-driven energy solutions. You'll architect scalable frontend systems, mentor junior developers, and build intuitive interfaces that make complex energy data accessible and actionable.",
    responsibilities: [
      "Design and develop responsive, scalable web applications using modern frontend frameworks",
      "Lead frontend architecture decisions and establish coding standards and best practices",
      "Collaborate with UX designers, backend engineers, and data scientists to deliver seamless user experiences",
      "Optimize application performance and ensure cross-browser compatibility",
      "Mentor junior frontend developers and conduct code reviews",
      "Participate in technical discussions with customers and stakeholders",
      "Contribute to the full software development lifecycle from conception to deployment"
    ],
    qualifications: [
      "6+ years of frontend development experience with increasing responsibility",
      "Frontend Frameworks: Advanced proficiency in React, Angular, or Vue.js (React preferred)",
      "Languages: Expert-level JavaScript/TypeScript, HTML5, CSS3",
      "State Management: Redux, MobX, or similar state management libraries",
      "Build Tools: Webpack, Vite, or similar bundling tools",
      "Version Control: Git with experience in collaborative development workflows",
      "UI/UX: Strong understanding of responsive design principles and accessibility standards",
      "Testing: Unit testing with Jest, Cypress, or similar frameworks",
      "APIs: Integration with RESTful APIs and GraphQL",
      "Performance: Experience with performance optimization and web vitals"
    ],
    goodToHave: [
      "Experience with data visualization libraries (D3.js, Chart.js, or similar)",
      "Knowledge of energy sector applications and complex data interfaces",
      "Experience with micro-frontend architectures",
      "Familiarity with design systems and component libraries",
      "Experience with Progressive Web Apps (PWA)",
      "Understanding of AI/ML model integration in frontend applications"
    ]
  },
  {
    id: "Dsr0026",
    title: "Director of Engineering – India",
    location: "Dsider | India",
    position: "Senior Level - Reports to CEO",
    postedOn: "January 28, 2026",
    travel: "Minimal",
    workModel: "Currently remote. Candidate willing to relocate to Bengaluru in future",
    country: "India, Bengaluru preferred (Remote will be considered)",
    aboutDsider: (
  <>
    Dsider is building an <strong>AI-powered decision platform</strong> grounded
    in <strong> first-principles simulation, optimization, and domain-specific knowledge. </strong>
    Our systems combine deterministic modeling, multi-agent AI, and
    explainable decision logic to help organizations make complex,
    high-impact decisions with confidence.
    As we scale globally, India is a critical engineering and delivery
    hub for Dsider.
  </>
),
    theRole: (
      <>
      We are seeking a <strong>Director of Engineering for India</strong> to lead and scale Dsider’s India engineering organization. 
      This role owns <strong> execution, quality, security, and delivery</strong> across Front-End, Back-End, AI/Agentic systems, QA, and Security teams.
      This is a hands-on leadership role with responsibility for building teams, driving execution, and establishing operating discipline. 
      The role has a <strong> clear progression to VP of Operations (India)</strong>, owning end-to-end engineering and operational outcomes in the region along with business development and growth in India and largely in Asian countries.
<br/><br/>
      <strong>Growth Path</strong><br/>
This role is designed to evolve into VP of Operations (India), owning:
End-to-end engineering delivery in India
Operational excellence and scaling strategy
Budgeting, hiring, and vendor relationships
Execution alignment with global company goals
Sales in India and other Asian countries.  
      </>
    ),
    responsibilities: 
    (
  <>
    <strong>Engineering Leadership & Delivery</strong>
    <ul>
      <li>Lead and manage multi-disciplinary engineering teams across Front-End, Back-End, AI/Agentic systems, QA, and Security.</li>
      <li>Own delivery timelines, execution quality, and technical outcomes for India-based teams.</li>
      <li>Translate product and platform strategy into execution plans, roadmaps, and milestones.</li>
      <li>Ensure consistent, predictable delivery across multiple concurrent initiatives.</li>
    </ul>

    <strong>Technical Oversight</strong>
    <ul>
      <li>Provide technical leadership and architectural oversight across the full stack.</li>
      <li>Ensure engineering designs align with Dsider’s simulation, optimization, and agentic AI architecture.</li>
      <li>Partner with architects and senior engineers to review designs, manage technical risk, and drive scalability.</li>
      <li>Establish standards for performance, reliability, observability, and maintainability.</li>
    </ul>

    <strong>AI, Security & Quality</strong>
    <ul>
      <li>Oversee development of AI and multi-agent systems, ensuring correctness, explainability, and robustness.</li>
      <li>Ensure security best practices across the platform, including access control, data protection, and compliance readiness.</li>
      <li>Own QA strategy, test automation, validation processes, and release quality.</li>
    </ul>

    <strong>People & Org Leadership</strong>
    <ul>
      <li>Build, mentor, and retain high-performing engineering teams in India.</li>
      <li>Develop engineering managers and senior ICs into technical and people leaders.</li>
      <li>Establish clear ownership, accountability, and performance expectations.</li>
    </ul>

    <strong>Operational Excellence</strong>
    <ul>
      <li>Implement scalable engineering processes, including sprint planning, release management, and incident response.</li>
      <li>Drive continuous improvement across velocity, quality, and cost efficiency.</li>
      <li>Partner with global leadership on budgeting, hiring plans, and vendor management.</li>
    </ul>

    <strong>Cross-Functional & Global Collaboration</strong>
    <ul>
      <li>Act as the primary India engineering leader working with US-based product, architecture, and leadership teams.</li>
      <li>Ensure strong communication, alignment, and execution across time zones.</li>
    </ul>
  </>
    ),
    qualifications: (
      <>
      <ul>
      <li>10 years of engineering experience, with 4+ years in engineering leadership roles.</li>
      <li>Proven experience managing Front-End, Back-End, AI/ML, Security, and QA teams.</li>
      <li>Strong understanding of distributed systems, cloud platforms (AWS preferred), and modern software architectures.</li>
      <li>Experience scaling engineering teams in a startup or high-growth environment.</li>
      <li>Ability to balance hands-on technical depth with people and operational leadership.</li>
    </ul>
      </>
    ),
    goodToHave: [
      "Experience leading India-based engineering organizations for startups.",
      "Exposure to AI platforms, simulation systems, or data-intensive products.",
      "Familiarity with security frameworks (SOC2, ISO 27001) and compliance processes."
    ]
  },
  {
    id: "Dsr0027",
    title: "Data Analytics Engineer",
    location: "Dsider | USA",
    position: "Intermediate Level (3+ years)",
    postedOn: "August 21, 2026",
    travel: "Minimal",
    workModel: "Remote, with preference for candidates in Houston",
    country: "United States",
    aboutDsider: (
  <>
    Dsider is an AI-powered decision intelligence platform for the energy sector. 
    We help companies transform complexity into clarity using AI models, digital twins, 
    and decision modeling tools — driving smarter, faster, and more profitable decisions across the energy value chain.
  </>
),
    theRole: (
  <>
    We're looking for a <strong>Data Analytics Engineer</strong> to improve and build a product 
    that delivers useful analytics to customers while owning the ETL pipelines and database design
     that power reliable platform analytics. You will validate that platform outputs are accurate, 
     explainable, and useful for end users, and QA product accuracy by checking metrics, calculations,
      edge cases, and data assumptions against expected results. Over time, you will build 
      subject-matter fluency in petroleum and heavy-industry operations, though prior domain knowledge
       is not required.
  </>
),
    responsibilities: [
      "Design, build, and maintain ETL/ELT pipelines that ingest, transform, and load industrial and operational data into the platform",
      "Design and evolve database schemas, tables, and models that support accurate, scalable analytics",
      "Use Python for data analysis, pipeline logic, validation scripts, and product accuracy checks",
      "Perform EDA and data quality analysis to characterize datasets, spot anomalies, and identify gaps before they affect product outputs",
      "Analyze how the platform handles real datasets and where accuracy, performance, or usability breaks down",
      "Test and validate product logic for operational and commercial metrics (e.g., production, downtime, throughput, cost)",
      "Reproduce accuracy issues, isolate root causes in data pipelines or schema design, and confirm fixes before release",
      "Partner with product and engineering to tighten definitions, improve data handling, and raise confidence in platform outputs",
      "Document data models, pipeline logic, assumptions, and validation checks so work is repeatable",
      "Help prioritize platform improvements based on impact to analytical correctness, data reliability, and user trust"
    ],
    qualifications: [
      "Strong analytical skills and comfort with imperfect, multi-source data",
      "Experience with EDA and data quality analysis (profiling, completeness, consistency, anomaly detection)",
      "Hands-on experience with ETL/ELT and SQL",
      "Expected fluency in Python for data work (analysis, transforms, automation, and validation)",
      "Experience designing relational databases / analytical schemas (normalization, keys, indexing)",
      "A QA mindset for analytical products: verifying logic, catching edge cases, and proving correctness",
      "Clear communication with product, engineering, and domain stakeholders",
      "Curiosity about industrial / petroleum production systems and willingness to learn the domain on the job",
      "Experience using AI tools and building agentic workflows.  RAG experience is a plus.",
      "Ability to build reliable ETL pipelines and well-designed databases that support trustworthy analytics",
      "Strong focus on analytical accuracy, with the ability to identify, investigate, and prevent recurring data and logic issues",
      "Ability to quickly detect, troubleshoot, and resolve incorrect metrics, data-quality issues, and edge-case failures",
      "Willingness and ability to develop fluency in petroleum and heavy-industry operations while learning the domain on the job",
      "Bonus (not required): cloud data warehouses, orchestration tools, or pipeline frameworks",
      "Bonus (not required): background in manufacturing, energy, oil & gas, or other heavy industry"
    ],
    goodToHave: [
      "Familiarity with time-series or sensor/operational data",
      "Experience writing acceptance criteria or validation checklists for analytics products",
      "Basic statistical methods for variance checks, anomaly detection, or forecast validation",
      "Comfort working closely with domain experts and customer-facing product teams"
    ]
  }
];

const JobDetails = () => {

  const { jobId } = useParams();
  const job = jobData.find((j) => j.id === jobId);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    currentSalary: "",
    expectedSalary: "",
    yearsOfExperience: "",
    resume: null,
    referralSource: ""
  });

  const [message, setMessage] = useState({ status: 0, value: "" });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "resume") {
      setFormData({ ...formData, resume: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  if (!job) {
    return (
      <PageShell title="Job not found | Dsider">
        <section className="hv2-section hv2-jobpage">
          <div className="hv2-container">
            <Link to="/careers#openings" className="hv2-jobpage__back">
              &larr; All open roles
            </Link>
            <h1>Role not found.</h1>
            <p className="hv2-jobpage__lead">
              This role is no longer open. See what we are hiring for now.
            </p>
          </div>
        </section>
      </PageShell>
    );
  }

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(",")[1]); // remove prefix
      reader.onerror = (error) => reject(error);
    });
  };

  async function handleSubmit() {
    if (isSubmitting) return; // prevent double clicks

    setIsSubmitting(true);

    try {
      const headers = {
        "Content-Type": "application/json",
        "Accept": "application/json",
      };

      let fileBase64 = null;
      let fileName = null;
      if (formData.resume) {
        fileBase64 = await fileToBase64(formData.resume);
        fileName = formData.resume.name;
      }

      if (!formData.resume) {
        setMessage({ status: 0, value: "Please upload your resume before submitting." });
        setTimeout(() => setMessage({ status: 0, value: "" }), 3000);
        return;
      }

      const requestData = {
        sheet_id: "1voJ7ozFGYqE-mbelORkiXGmhB-97E-Bn6Qvl0Px-3bU",
        identifier: "sheet_and_drive",
        sheet_name: "Careers",
        data: {
          "JobID": jobId,
          "JobTitle": job.title,
          "Name": formData.name,
          "Email": formData.email,
          "currentSalary": formData.currentSalary,
          "expectedSalary": formData.expectedSalary,
          "YearsOfExperience": formData.yearsOfExperience,
          "Source": formData.referralSource,
          "AppliedOn": new Date().toLocaleDateString("en-GB"),
        },
        file_base64: fileBase64,
        file_name: fileName,
        folder_id: "0AFFLkDSFN5r1Uk9PVA"
      };
      const response = await axios.post(
        "https://5l2ipjsrylacx3h7cxu4sqob6y0lnfsv.lambda-url.us-east-1.on.aws",
        requestData, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        mode: 'cors'  // Added CORS mode here
      });
      if (response.status >= 200 && response.status < 300) {
        setMessage({ status: 1, value: "Application submitted successfully." });
        setTimeout(() => setMessage({ status: 0, value: "" }), 3000);
        // Reset form
        setFormData({
          name: "",
          email: "",
          currentSalary: "",
          expectedSalary: "",
          yearsOfExperience: "",
          resume: null,
          referralSource: ""
        });
      } else {
        throw new Error(`Request failed with status ${response.status}`);
      }
    } catch (error) {
      console.error("Full error:", error);
      setMessage({
        status: 0,
        value: error.response?.data?.message ||
          "There was a problem sending your request. Please try again later.",
      });
    }
    finally {
      setIsSubmitting(false);
    }
  }


  const list = (items) =>
    Array.isArray(items) ? (
      <ul className="hv2-jobpage__list">
        {items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    ) : (
      <div className="hv2-jobpage__text">{items}</div>
    );

  const field = (id, label, props = {}) => (
    <label className="hv2-field" htmlFor={id}>
      <span>{label}</span>
      <input
        id={id}
        name={id}
        value={formData[id]}
        onChange={handleChange}
        required
        {...props}
      />
    </label>
  );

  return (
    <PageShell
      title={`${job.title} | Careers | Dsider`}
      description={`Apply for the ${job.title} role at Dsider.`}
    >
      <section className="hv2-jobpage-hero">
        <div className="hv2-jobpage-hero__inner">
          <Link to="/careers#openings" className="hv2-jobpage__back hv2-hero-in">
            &larr; All open roles
          </Link>
          <span className="hv2-pill hv2-hero-in" style={{ "--d": 0 }}>
            <i aria-hidden="true" />
            {job.position}
          </span>
          <h1 className="hv2-hero-in" style={{ "--d": 1 }}>
            {job.title}
          </h1>
          <div className="hv2-job__meta hv2-hero-in" style={{ "--d": 2 }}>
            <span>{job.location}</span>
            <span>{job.workModel}</span>
            <span>Posted {job.postedOn}</span>
          </div>
        </div>
      </section>

      <section className="hv2-section hv2-jobpage">
        <div className="hv2-jobpage__grid">
          <article className="hv2-jobpage__content">
            <h2 className="hv2-reveal">About Dsider</h2>
            <div className="hv2-jobpage__text hv2-reveal">{job.aboutDsider}</div>

            <h2 className="hv2-reveal">The role</h2>
            <div className="hv2-jobpage__text hv2-reveal">{job.theRole}</div>

            <h2 className="hv2-reveal">Key responsibilities</h2>
            {list(job.responsibilities)}

            <h2 className="hv2-reveal">Qualifications</h2>
            {list(job.qualifications)}

            <h2 className="hv2-reveal">Nice to have</h2>
            {list(job.goodToHave)}

            <h2 className="hv2-reveal">Work model</h2>
            <dl className="hv2-jobpage__facts">
              <div>
                <dt>Location</dt>
                <dd>{job.country}</dd>
              </div>
              <div>
                <dt>Work model</dt>
                <dd>{job.workModel}</dd>
              </div>
              <div>
                <dt>Travel</dt>
                <dd>{job.travel}</dd>
              </div>
            </dl>
          </article>

          <aside className="hv2-jobpage__apply">
            <form
              className="hv2-form"
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              <h3>Apply for this role</h3>
              <div className="hv2-form__row">
                {field("name", "Name *", { type: "text", placeholder: "Your name" })}
                {field("email", "Email *", { type: "email", placeholder: "you@email.com" })}
              </div>
              {!job.location.includes("USA") && (
                <div className="hv2-form__row">
                  {field("currentSalary", "Current salary *", { type: "text" })}
                  {field("expectedSalary", "Expected salary *", { type: "text" })}
                </div>
              )}
              {field("yearsOfExperience", "Years of experience *", {
                type: "text",
                inputMode: "numeric",
                placeholder: "e.g. 4",
                onKeyPress: (e) => {
                  if (!/[0-9]/.test(e.key)) e.preventDefault();
                },
                onPaste: (e) => {
                  const paste = (e.clipboardData || window.clipboardData).getData("text");
                  if (!/^[0-9]+$/.test(paste)) e.preventDefault();
                },
              })}
              <label className="hv2-field" htmlFor="referralSource">
                <span>How did you hear about this role?</span>
                <select
                  id="referralSource"
                  name="referralSource"
                  value={formData.referralSource}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select an option</option>
                  <option value="LinkedIn">LinkedIn</option>
                  <option value="Google Search">Google Search</option>
                  <option value="Dsider Team">Dsider Team</option>
                  <option value="Others">Others</option>
                </select>
              </label>
              <div className="hv2-field">
                <span>Resume * (PDF or Word, max 5 MB)</span>
                <label htmlFor="resume" className="hv2-upload">
                  {formData.resume ? formData.resume.name : "Choose a file"}
                </label>
                <input
                  type="file"
                  id="resume"
                  name="resume"
                  accept=".pdf,.doc,.docx"
                  onChange={handleChange}
                  className="hv2-upload__input"
                />
              </div>
              {message.value && (
                <p
                  className={`hv2-form__status hv2-form__status--${message.status === 1 ? "success" : "error"}`}
                  role="status"
                >
                  {message.value}
                </p>
              )}
              <button
                type="submit"
                className="hv2-btn hv2-btn--primary hv2-btn--block"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit application"}
              </button>
              <button
                type="button"
                className="hv2-jobpage__reset"
                onClick={() => {
                  setFormData({
                    name: "",
                    email: "",
                    currentSalary: "",
                    expectedSalary: "",
                    yearsOfExperience: "",
                    resume: null,
                    referralSource: "",
                  });
                  const input = document.getElementById("resume");
                  if (input) input.value = "";
                }}
              >
                Reset
              </button>
            </form>
          </aside>
        </div>
      </section>
    </PageShell>
  );
};

export default JobDetails;
